import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { memo, useMemo } from "react";
import { tagMappers } from "./tag-mappers";
import rehypeSanitize from "rehype-sanitize";
import { Typography } from "@mui/material";
import { filterMapper } from "./tag-mappers/filter.mapper";

type Props = {
  text: string;
};

export const MarkdownSyntaxHighlighter = memo(function Component(props: Props) {
  const { text } = props;
  return (
    <ReactMarkdown
      components={{
        ...tagMappers,
      }}
      remarkPlugins={[remarkGfm]}
    >
      {text}
    </ReactMarkdown>
  );
});

const EmptyState = () => (
  <Typography variant="body2" sx={{ fontStyle: "italic", opacity: 0.7 }}>
    No valid content available.
  </Typography>
);

export const LimitedMarkdownRenderer = memo(function Component(props: Props) {
  const { text } = props;
  const renderedContent = useMemo(() => {
    const rendered = ReactMarkdown({
      children: text,
      rehypePlugins: [rehypeSanitize],
      remarkPlugins: [remarkGfm],
      components: {
        a: tagMappers.a,
        img: tagMappers.img,
        h1: filterMapper,
        h2: filterMapper,
        h3: filterMapper,
        h4: filterMapper,
        h5: filterMapper,
        h6: filterMapper,
        blockquote: filterMapper,
        code: filterMapper,
        pre: filterMapper,
        ul: filterMapper,
        ol: filterMapper,
        li: filterMapper,
        table: filterMapper,
        thead: filterMapper,
        tbody: filterMapper,
        tr: filterMapper,
        td: filterMapper,
        th: filterMapper,
        em: filterMapper,
        strong: filterMapper,
        del: filterMapper,
        hr: () => null,
        br: () => null,
        html: () => null,
      },
    });

    const content = rendered.props.children;

    if (!content || (typeof content === "string" && content.trim() === "")) {
      return "";
    } else {
      return content;
    }
  }, [text]);

  return <>{renderedContent ? renderedContent : <EmptyState />}</>;
});
